import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import { useMemo } from 'react';
import { TIMEZONE } from '../constants';

dayjs.extend(timezone);

export function DateTime({
  t,
  format = 'dddd, MMM D',
  className = 'whitespace-nowrap',
  timezone = TIMEZONE,
}) {
  const text = useMemo(() => dayjs(t).tz(timezone).format(format), [format, t, timezone]);
  return <time className={className}>{text}</time>;
}
